module.exports = __webpack_public_path__ + "img/shensu.429f22ad.png";